/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loud_Wild_Gazelle_SnapInputs */

const fr_loud_wild_gazelle_snap = /** @type {(inputs: Loud_Wild_Gazelle_SnapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions`)
};

/**

* @param {Loud_Wild_Gazelle_SnapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const loud_wild_gazelle_snap = /** @type {((inputs?: Loud_Wild_Gazelle_SnapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Wild_Gazelle_SnapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_loud_wild_gazelle_snap(inputs)
});